import React from 'react';
import { Link } from 'react-router-dom';

function Footer() {
  return (
    <footer className="site-footer">
      <div className="footer-container">

        {/* Brand Section */}
        <div className="footer-section brand-section">
          <h3>Bunny Boutique 321</h3>
          <p>
            Specializing in happy, healthy, and well-socialized companions.
            Ethically raised with love to become the perfect addition to your family.
          </p>
        </div>

        {/* Navigation Section */}
        <div className="footer-section">
          <h4>Quick Links</h4>
          <ul>
            <li><Link to="/">Home</Link></li>
            <li><Link to="/available">Available Bunnies</Link></li>
            <li><Link to="/our-bunnies">Our Bunnies</Link></li>
            <li><Link to="/past-babies">Past Babies</Link></li>
            <li><Link to="/application">Application</Link></li>
            <li><Link to="/merchandise">Merchandise</Link></li>
          </ul>
        </div>

        {/* Social Media Section */}
        <div className="footer-section">
          <h4>Connect With Us</h4>
          <div className="social-links">
            {/* Replace the href links with your actual social media URLs */}
            <a href="https://www.instagram.com/the_bunny_boutique321/" target="_blank" rel="noopener noreferrer">Instagram</a>
            <a href="https://www.facebook.com/people/The-bunny-boutique/61554858969631/" target="_blank" rel="noopener noreferrer">Facebook</a>
            <a href="https://www.tiktok.com/@the_bunnyboutique_321" target="_blank" rel="noopener noreferrer">TikTok</a>
            <Link to="/contact" className="footer-contact-link">Contact Us</Link>
          </div>
        </div>

        {/* Contact Details Section */}
        <div className="footer-section">
          <h4>Get In Touch</h4>
          <div className="social-links">
            <a href="mailto:sales@bunnyboutique321.com">sales@bunnyboutique321.com</a>
            <a href="tel:+13217209802">321-720-9802</a>
          </div>
        </div>

      </div>

      {/* Copyright Bar */}
      <div className="footer-bottom">
        <p>&copy; {new Date().getFullYear()} Bunny Boutique 321. All rights reserved.</p>
      </div>
    </footer>
  );
}

export default Footer;